import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-primary py-12 px-[5%] border-t border-[rgba(76,201,240,0.1)] relative overflow-hidden">
      {/* Animated background gradient */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute w-full h-full bg-gradient-to-r from-accent-primary via-accent-secondary to-accent-tertiary animate-gradient-shift" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center relative z-10"
      >
        <motion.p
          className="text-text-muted text-sm sm:text-base"
          whileHover={{ scale: 1.05 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          &copy; {currentYear} Kuruva Pavani. Built with passion and code.
        </motion.p>
        
        <motion.div
          className="mt-4 flex justify-center gap-2"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <motion.span
            className="inline-block w-2 h-2 bg-accent-primary rounded-full"
            animate={{
              scale: [1, 1.5, 1],
              opacity: [1, 0.5, 1],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />
          <motion.span
            className="inline-block w-2 h-2 bg-accent-secondary rounded-full"
            animate={{
              scale: [1, 1.5, 1],
              opacity: [1, 0.5, 1],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.3,
            }}
          />
          <motion.span
            className="inline-block w-2 h-2 bg-accent-tertiary rounded-full"
            animate={{
              scale: [1, 1.5, 1],
              opacity: [1, 0.5, 1],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.6,
            }}
          />
        </motion.div>
      </motion.div>
    </footer>
  );
};

export default Footer;
